import { DataVariants, EnumOption } from "../../../data/DataManager";
import { GridRenderSlots } from "../../../grid/AgGridManager";
import { InputTypes } from "../../../form/FormManager";
import { EMPTY_VALUE, FieldSchema } from "../../../Schema";
import { LinkedInstance } from "../external-sources/LinkedInstances";
import { SchemaContext } from "../../common";
import { Modes } from "./mode";

export const createLinkedInstance = (context: SchemaContext): FieldSchema => ({
  name: "linkedInstance",
  grid: {
    displayed: true,
    order: 55,
    render: GridRenderSlots.LINKED_INSTANCE,
  },
  dataTransform: {
    fromGraphql: {
      getter: ({ linkedInstance }) =>
        context.linkedInstances.find(
          (linkedInstanceItem) => linkedInstanceItem.linkedInstance === linkedInstance
        ) || EMPTY_VALUE,
    },
    fromCsv: {
      getter: ({ linkedInstance }) => {
        // Already resolved by the parser, which matched the display name.
        if (linkedInstance && typeof linkedInstance === "object") {
          return linkedInstance;
        }
        if (!linkedInstance) {
          return EMPTY_VALUE;
        }
        return context.linkedInstances.find(
          (item) => item.linkedInstance === linkedInstance
        ) ?? linkedInstance;
      },
    },
    toGraphql: {
      getter: ({ linkedInstance }) => {
        if (linkedInstance) {
          return (linkedInstance as LinkedInstance).linkedInstance ?? EMPTY_VALUE;
        }
        return EMPTY_VALUE;
      },
    },
    // As with siteName: the database holds the name, not the object fromGraphql inflates
    // it into.
    toDb: {
      getter: ({ linkedInstance }) => {
        if (linkedInstance) {
          return (linkedInstance as LinkedInstance).linkedInstance ?? EMPTY_VALUE;
        }
        return EMPTY_VALUE;
      },
    },
  },
  data: {
    variant: DataVariants.ENUM,
    options: {
      getter: ({ mode }) => {
        return context.linkedInstances.map((linkedInstanceItem) => {
          if (
            mode === Modes.CREATE &&
            linkedInstanceItem.disableManualLinking
          ) {
            return null;
          }
          return ({
            value: linkedInstanceItem,
            label: linkedInstanceItem.linkedInstanceDisplay,
          })
        }).filter(Boolean) as EnumOption<LinkedInstance>[];
      },
      fields: ["mode"],
    }
  },
  display: {
    displayed: true,
  },
  validation: { required: true },
  form: {
    label: "Linked instance",
    type: InputTypes.SELECT,
    disabled: {
      getter: ({ mode }) => {
        return [Modes.EDIT, Modes.BULK_EDIT].includes(mode as Modes);
      },
      fields: ["mode"],
    }
  },
});
